import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
const options = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const defaultEnumEncode = dictGeneric => dictGenericEncodeEnum => x => dictGenericEncodeEnum.encodeEnum({constructorTagTransform: x$1 => x$1})(dictGeneric.from(x));
const defaultEnumDecode = dictGeneric => dictGenericDecodeEnum => x => Foreign$dGeneric$dEnumEncoding.genericDecodeEnum(dictGeneric)(dictGenericDecodeEnum)({
  constructorTagTransform: x$1 => x$1
})(x);
const defaultEncodeJSON = dictGeneric => dictGenericEncode => x => Foreign$dGeneric.genericEncodeJSON(dictGeneric)(dictGenericEncode)(options)(x);
const defaultEncode = dictGeneric => dictGenericEncode => x => dictGenericEncode.encodeOpts(options)(dictGeneric.from(x));
const defaultDecodeJSON = dictGeneric => dictGenericDecode => x => Foreign$dGeneric.genericDecodeJSON(dictGeneric)(dictGenericDecode)(options)(x);
const defaultDecode = dictGeneric => dictGenericDecode => x => Foreign$dGeneric.genericDecode(dictGeneric)(dictGenericDecode)(options)(x);
export {defaultDecode, defaultDecodeJSON, defaultEncode, defaultEncodeJSON, defaultEnumDecode, defaultEnumEncode, options};
